module.exports = "<!-- ============================================================== -->\r\n<!-- Only router without any element -->\r\n<!-- ============================================================== -->\r\n<router-outlet></router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/layouts/blank/blank.component.html
// module id = ./src/app/layouts/blank/blank.component.html
// module chunks = main